import { Lightbulb } from "lucide-react";

const PRIORITY_STYLES = {
  high:   { label: "Alta",  color: "text-red-700 bg-red-50 border-red-100" },
  medium: { label: "Média", color: "text-amber-700 bg-amber-50 border-amber-100" },
  low:    { label: "Baixa", color: "text-blue-700 bg-blue-50 border-blue-100" },
};

const TYPE_LABELS = {
  recovery:   "Recuperação",
  conversion: "Conversão",
  upsell:     "Upsell",
  channel:    "Canal",
};

function EmptyRecs() {
  return (
    <div className="bg-gray-50 rounded-xl px-4 py-5 text-center">
      <Lightbulb className="w-5 h-5 text-gray-300 mx-auto mb-2" />
      <p className="text-xs text-gray-400">
        A Karol ainda está observando dados suficientes.
      </p>
    </div>
  );
}

export function KarolRecommendationsSection({ recommendations }) {
  return (
    <div className="space-y-3" data-testid="karol-recommendations">
      <div className="flex items-center gap-2 px-1">
        <div className="h-px flex-1 bg-gray-100" />
        <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
          Recomendações
        </span>
        <div className="h-px flex-1 bg-gray-100" />
      </div>

      {!recommendations || recommendations.length === 0 ? (
        <EmptyRecs />
      ) : (
        <div className="space-y-2">
          {recommendations.map((rec, i) => {
            const p = PRIORITY_STYLES[rec.priority] ?? PRIORITY_STYLES.low;
            return (
              <div
                key={i}
                className="bg-white rounded-xl border border-gray-100 shadow-sm p-4"
              >
                <div className="flex items-start justify-between gap-3 mb-1.5">
                  <p className="text-sm font-semibold text-gray-800 leading-snug">
                    {rec.title}
                  </p>
                  <div className="flex gap-1.5 flex-shrink-0 mt-0.5">
                    <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full border ${p.color}`}>
                      {p.label}
                    </span>
                    <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">
                      {TYPE_LABELS[rec.type] ?? rec.type}
                    </span>
                  </div>
                </div>
                <p className="text-xs text-gray-500 leading-relaxed">
                  {rec.description}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
